import { FC, ReactElement, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ArrowRightIcon, MplButton } from '@mopla/ui';

import { Bold } from '../RegistrationForm/RegistrationForm.styles';

import { Description, Root, Title } from './ResendEmail.styles';

interface ResendEmailProps {
	onSubmit: () => void;
	email: string;
	loading?: boolean;
	render: (p: { content: ReactNode; submit: ReactNode }) => ReactElement;
}

/** TODO redesign */
export const ResendEmail: FC<ResendEmailProps> = ({
	onSubmit,
	email,
	loading = false,
	render,
}) => {
	const { t } = useTranslation('registration');

	return render({
		content: (
			<Root>
				<Title data-testid="registration-letsDoThatAgain-text">
					{t('resendVerify.text.title1')}
				</Title>
				<Title>
					<Trans
						i18nKey="registration:resendVerify.text.title2"
						values={{ regEmail: email }}
						components={{ bold: <Bold /> }}
					/>
				</Title>
				<Description marginTop="24px">
					{t('resendVerify.text.description2')}
				</Description>
			</Root>
		),
		submit: (
			<MplButton
				fullWidth
				color="primaryButtonV2"
				endIcon={<ArrowRightIcon />}
				onClick={onSubmit}
				disabled={loading}
			>
				{t('resendVerify.button.send_again')}
			</MplButton>
		),
	});
};
